import { ref } from 'vue'

export type ToastKind = 'success' | 'error' | 'info'

export interface Toast {
  id: number
  kind: ToastKind
  message: string
}

// Module-level singleton so stores and components share one toast queue.
const toasts = ref<Toast[]>([])
let nextId = 1

function dismiss(id: number) {
  toasts.value = toasts.value.filter((t) => t.id !== id)
}

function push(kind: ToastKind, message: string, timeoutMs = 5000) {
  const id = nextId++
  toasts.value.push({ id, kind, message })
  if (timeoutMs > 0) {
    setTimeout(() => dismiss(id), timeoutMs)
  }
  return id
}

export function useToast() {
  return {
    toasts,
    push,
    dismiss,
    success: (message: string) => push('success', message),
    error: (message: string) => push('error', message),
    info: (message: string) => push('info', message),
  }
}
